export class LoadPlacementsEvent {
    public static readonly type = '[JobsPlacements] Load placements event';
}
